/**
 * /impersonate - entrada e saída da aba de suporte.
 *
 * Entrada: o AuthContext já consumiu `#imp=...` antes do render; com sessão
 * ativa, segue para o app do cliente. Saída/expiração: mostra o aviso e
 * oferece fechar a aba (a sessão do admin segue intacta na aba original).
 */

import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { ShieldCheck } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useAuth } from '@/contexts/AuthContext';

const ImpersonatePage: React.FC = () => {
  const { impersonation } = useAuth();

  useEffect(() => {
    if (!impersonation) document.title = 'Sessão de suporte encerrada';
  }, [impersonation]);

  if (impersonation) return <Navigate to="/" replace />;

  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-4">
      <div className="max-w-sm w-full text-center space-y-4">
        <ShieldCheck className="h-10 w-10 mx-auto text-primary" />
        <h1 className="text-lg font-semibold text-foreground">Sessão de suporte encerrada</h1>
        <p className="text-sm text-muted-foreground">
          A sessão terminou ou expirou. Sua sessão de admin continua aberta na aba original.
        </p>
        <div className="flex justify-center gap-2">
          <Button onClick={() => window.close()}>Fechar esta aba</Button>
          <Button variant="outline" onClick={() => window.location.replace('/admin/grow-ops')}>
            Ir para o admin
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ImpersonatePage;
